export class ProtocolClient {
    emitEvent(type, data) {
        var _this_eventHandlers_get;
        (_this_eventHandlers_get = this.eventHandlers.get(type)) === null || _this_eventHandlers_get === void 0 ? void 0 : _this_eventHandlers_get(data);
    }
    onEvent(eventType, handler) {
        if (this.eventHandlers.get(eventType) != undefined) throw new Error(`Event type ${eventType} already has a handler`);
        this.eventHandlers.set(eventType, handler);
    }
    removeListener(eventType) {
        this.eventHandlers.delete(eventType);
    }
    send(commandType, data) {
        this.sendFromClientToServer({
            type: commandType,
            ...data
        });
    }
    constructor(sendFromClientToServer){
        this.eventHandlers = new Map();
        this.sendFromClientToServer = sendFromClientToServer;
    }
}
